import React from 'react'

const OurValues = () => {
    return (
        <div>OurValues</div>
    )
}

export default OurValues